<script>
import api from '@/helpers/api'
export default {
  name: 'product.info',
  props: {
    product_id: { type: String, required: true }
  },
  data: () => ({
    isLoading: false,
    product: {}
  }),
  mounted () {
    this.onInit()
  },
  watch: {
    product_id: { handler: 'onInit', immediate: true }
  },
  methods: {
    onProductSelected (p) {
      this.selected = p
    },
    async onInit () {
      this.isLoading = true
      let item = await api.items.fetch({
        id: this.product_id
      })
      this.product = {
        ...item
      }
      this.isLoading = false
    },
    async onSave () {
      let valid = true

      if (valid) {
        const data = {
          ...this.product
        }

        try {
          this.isLoading = true
          let item = await api.items.update({
            ...data,
            id: this.product_id
          })
          this.$bvToast.toast(`Product info was saved!`, {
            title: 'Changes Saved',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'success',
            autoHideDelay: 1000,
            appendToast: true
          })
          this.$emit('update')
          this.isLoading = false
        } catch (error) {
          this.isLoading = false

          this.$bvToast.toast(`${error}!`, {
            title: 'Error',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            autoHideDelay: 1000,
            appendToast: true
          })
        }
      }
    }
  }
}
</script>
<template>
  <g-overlay :show="isLoading">
    <b-card>
      <h4 class="card-title border-bottom pb-3 mb-4">Basic Information</h4>
      <b-form-group
        label="Code *"
        label-for="product_code"
        label-cols-sm="3"
        label-cols-lg="2"
      >
        <b-form-input
          id="product_code"
          v-model="product.code"
          type="text"
          required
          autocomplete="product_code"
          placeholder="Unique Code"
          :style="{ maxWidth: '200px' }"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label="Short Description"
        label-for="product_description"
        label-cols-sm="3"
        label-cols-lg="2"
      >
        <b-form-textarea
          id="product_description"
          v-model="product.short_description"
          type="text"
          required
          autocomplete="product_description"
          placeholder="Short description"
          rows="2"
          max-rows="3"
          :style="{ maxWidth: '500px' }"
        ></b-form-textarea>
      </b-form-group>

      <b-form-group
        label="Category"
        label-for="product_category_id"
        label-cols-sm="3"
        label-cols-lg="2"
      >
        <app-category-selector
          v-model="product.category_id"
          id="product_category_id"
          :style="{ maxWidth: '300px' }"
        />
      </b-form-group>
      <h4 class="card-title border-bottom pb-3 mb-4 mt-5">Options</h4>
      <b-form-group label-for="is_sellable" label-cols-lg="2" label-cols-sm="3">
        <template v-slot:label> Available for Sale </template>
        <b-form-checkbox
          switch
          size="lg"
          id="is_sellable"
          v-model="product.is_sellable"
          name="is_sellable"
          class="py-2"
        ></b-form-checkbox>
      </b-form-group>
      <b-form-group
        label-for="is_purchaseable "
        label-cols-lg="2"
        label-cols-sm="3"
      >
        <template v-slot:label> Enable Purchasing </template>
        <b-form-checkbox
          switch
          size="lg"
          id="is_purchaseable "
          v-model="product.is_purchaseable"
          name="is_purchaseable "
          class="py-2"
        ></b-form-checkbox>
      </b-form-group>
      <b-form-group
        label-for="is_stock_item"
        label-cols-lg="2"
        label-cols-sm="3"
      >
        <template v-slot:label> Manage Inventory </template>
        <b-form-checkbox
          switch
          size="lg"
          id="is_stock_item"
          v-model="product.is_stock_item"
          name="is_stock_item"
          class="py-2"
          :disabled="product.is_assembly"
        ></b-form-checkbox>
      </b-form-group>
      <b-form-group label-for="is_assembly" label-cols-lg="2" label-cols-sm="3">
        <template v-slot:label> Assembly Product </template>
        <b-form-checkbox
          switch
          size="lg"
          id="is_assembly"
          v-model="product.is_assembly"
          name="is_assembly"
          class="py-2"
        ></b-form-checkbox>
      </b-form-group>
      <b-form-group label-for="is_material" label-cols-lg="2" label-cols-sm="3">
        <template v-slot:label> Is Material </template>
        <b-form-checkbox
          switch
          size="lg"
          id="is_material"
          v-model="product.is_material"
          name="is_material"
          class="py-2"
        ></b-form-checkbox>
      </b-form-group>
      <b-form-group
        label-for="allow_grouping"
        label-cols-lg="2"
        label-cols-sm="3"
      >
        <template v-slot:label> Allow Grouping </template>
        <b-form-checkbox
          switch
          size="lg"
          id="allow_grouping"
          v-model="product.allow_grouping"
          name="allow_grouping"
          class="py-2"
        ></b-form-checkbox>
      </b-form-group>
      <div class="d-flex justify-content-end border-top pt-3">
        <b-btn class="btn-label" variant="primary" v-on:click="onSave">
          <i class="bx bx-save label-icon"></i>Save Changes
        </b-btn>
      </div>
    </b-card>
  </g-overlay>
</template>
